
import { useState, useEffect, useRef } from "react"
import image from "../assests/image.png"
import { useNavigate } from "react-router-dom"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import pranaamlogo from "../assests/Pranam-Logo.png";
import SuccessModal from "../components/sucesspage";
function BMIForm() {
  const navigate = useNavigate();
  // const formRef = useRef();
  const invoiceRef = useRef();
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  // Form state
  const [formData, setFormData] = useState({
    full_name: "",
    gender: "",
    age: "",
    date_of_birth: "",
    contact_number: "",
    height_cm: "",
    weight_kg: "",
    bmi: "",
    body_fat_percent: "",
    visceral_fat_level: "",
    body_age: "",
    resting_metabolism_kcal: "",
    concern: "",
    observation: "",
    suggestion: "",
    doctor_name: "",
  })
  const materialColors = {
    background: "#ffffff",
    cardBackground: "#ffffff",
    headingColor: "#d32f2f", // Dark Red for headings
    textPrimary: "#000000",
    textSecondary: "#333333",
    border: "#ccc",
    buttonBackground: "#ffc107",
    buttonText: "#263238",
  };

  const labelStyle = {
    fontWeight: "bold",
    color: "rgb(139, 29, 29)",
    textAlign: "left",
    paddingRight: "2px", // reduced space between label and colon
  };

  const colonStyle = {
    textAlign: "center",
    width: "10px",
  };

  const valueStyle = {
    color: "#000",
  };




  // const labelStyle = {
  //   width: "150px",
  //   color: "maroon",
  //   fontWeight: "bold",
  // };

  // const valueStyle = {
  //   color: "#333",
  // };
  // Validation errors state
  const [errors, setErrors] = useState({})
  const [calculatedBMI, setCalculatedBMI] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState({ show: false, success: false, message: "" })
  const [showSuccessPage, setShowSuccessPage] = useState(false)
  const [showInvoice, setShowInvoice] = useState(false);
  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  // Calculate BMI
  function calculateBMI(height, weight) {
    const heightInM = Number.parseFloat(height) / 100
    const weightInKg = Number.parseFloat(weight)

    if (isNaN(heightInM) || isNaN(weightInKg) || heightInM === 0) {
      return ""
    }

    const bmi = (weightInKg / (heightInM * heightInM)).toFixed(2)
    return bmi
  }

  // Update BMI when height or weight changes
  useEffect(() => {
    if (formData.height_cm && formData.weight_kg) {
      const bmi = calculateBMI(formData.height_cm, formData.weight_kg)
      if (bmi !== calculatedBMI) {
        setCalculatedBMI(bmi)
        setFormData((prevData) => ({
          ...prevData,
          bmi: bmi,
        }))
      }
    }
  }, [formData.height_cm, formData.weight_kg, calculatedBMI])

  // Form validation
  const validateForm = () => {
    const newErrors = {}

    if (!formData.full_name || formData.full_name.length < 2) {
      newErrors.full_name = "Name must be at least 2 characters."
    }

    if (!formData.gender) {
      newErrors.gender = "Please select a gender."
    }

    if (!formData.age) {
      newErrors.age = "Please enter age."
    }

    // if (!formData.contact_number || formData.contact_number.length < 10) {
    //   newErrors.contact_number = "Contact number must be at least 10 digits."
    // }
    const contact = formData.contact_number;

    if (!contact) {
      newErrors.contact_number = "Contact number is required.";
    } else if (!/^\d+$/.test(contact)) {
      newErrors.contact_number = "Only numeric digits are allowed.";
    } else if (contact.length !== 10) {
      newErrors.contact_number = "Contact number must be exactly 10 digits.";
    } else if (!/^[6|7|8|9]/.test(contact)) {
      newErrors.contact_number = "Contact number must start with 6, 7, 8 or 9.";
    }

    if (!formData.height_cm) {
      newErrors.height_cm = "Please enter height."
    }

    if (!formData.weight_kg) {
      newErrors.weight_kg = "Please enter weight."
    }

    return newErrors
  }

  // Submit data to backend API
  const submitToBackend = async (data) => {
    try {
      setIsSubmitting(true)

      const response = await fetch("https://feedback.pranaamhospitals.com/index.php/BMI/bmi_assessment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      const result = await response.json()

      // Only show success page after successful API response
      setShowSuccessPage(true)

      console.log("Form submission successful:", result)
      return true
    } catch (error) {
      console.error("Error submitting form:", error)

      setSubmitStatus({
        show: true,
        success: false,
        message: `Error submitting form: ${error.message}`,
      })

      return false
    } finally {
      setIsSubmitting(false)
    }
  }


  // const MAX_PDF_SIZE_MB = 10;

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const formErrors = validateForm();
  //   setErrors(formErrors);

  //   if (Object.keys(formErrors).length === 0) {
  //     setLoading(true);
  //     setShowInvoice(true);

  //     setTimeout(async () => {
  //       const input = invoiceRef.current;
  //       if (!input) {
  //         setLoading(false);
  //         return;
  //       }

  //       try {
  //         const canvas = await html2canvas(input, {
  //           scale: 2,
  //           useCORS: true,
  //           allowTaint: true,
  //           scrollY: -window.scrollY,
  //         });

  //         const imgData = canvas.toDataURL("image/jpeg", 0.95); // High quality
  //         const imgWidth = 595.28; // A4 width in px at 72dpi
  //         const pageHeight = 841.89;
  //         // A4 height in px at 72dpi

  //         const canvasWidth = canvas.width;
  //         const canvasHeight = canvas.height;
  //         const imgHeight = (imgWidth * canvasHeight) / canvasWidth;

  //         let heightLeft = imgHeight;
  //         let position = 0;

  //         const pdf = new jsPDF("p", "pt", "a4");

  //         while (heightLeft > 0) {
  //           pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight,);
  //           heightLeft -= pageHeight;

  //           if (heightLeft > 0) {
  //             position = - (imgHeight - heightLeft);
  //             pdf.addPage();
  //           }
  //         }

  //         const pdfBlob = pdf.output("blob");
  //         const pdfSizeMB = pdfBlob.size / 1024 / 1024;

  //         if (pdfSizeMB > MAX_PDF_SIZE_MB) {
  //           alert(`Generated PDF is too large (${pdfSizeMB.toFixed(2)} MB). Please reduce content.`);
  //           setShowInvoice(false);
  //           setLoading(false);
  //           return;
  //         }

  //         const formDataToUpload = new FormData();
  //         for (const key in formData) {
  //           if (formData[key] !== undefined && formData[key] !== null) {
  //             formDataToUpload.append(key, formData[key]);
  //           }
  //         }

  //         formDataToUpload.set("age", parseInt(formData.age || 0));
  //         formDataToUpload.set("height_cm", parseFloat(formData.height_cm || 0));
  //         formDataToUpload.set("weight_kg", parseFloat(formData.weight_kg || 0));
  //         formDataToUpload.set("bmi", parseFloat(formData.bmi || 0));
  //         formDataToUpload.set("body_fat_percent", parseFloat(formData.body_fat_percent || 0));
  //         formDataToUpload.set("visceral_fat_level", parseFloat(formData.visceral_fat_level || 0));
  //         formDataToUpload.set("body_age", parseInt(formData.body_age || 0));
  //         formDataToUpload.set("resting_metabolism_kcal", parseInt(formData.resting_metabolism_kcal || 0));
  //         formDataToUpload.append("created_at", new Date().toISOString().split("T")[0]);

  //         formDataToUpload.append("pdf_file", pdfBlob, "BMI_Report.pdf");

  //         const response = await fetch("https://feedback.pranaamhospitals.com/index.php/BMI/bmi_assessment", {
  //           method: "POST",
  //           body: formDataToUpload,
  //         });

  //         const result = await response.json();

  //         if (result.status === "Success") {
  //           setShowInvoice(false);
  //           resetForm();
  //           setShowSuccessPopup(true);
  //         } else {
  //           console.error("Server error:", result.message || result);
  //         }

  //         setLoading(false);
  //       } catch (error) {
  //         console.error("Error during PDF generation or submission:", error);
  //         setLoading(false);
  //         setShowInvoice(false);
  //       }
  //     }, 200);
  //   } else {
  //     const firstError = document.querySelector(".text-red-500");
  //     if (firstError) {
  //       firstError.scrollIntoView({ behavior: "smooth", block: "center" });
  //     }
  //   }
  // };

  const MAX_PDF_SIZE_MB = 10;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setLoading(true);
      setShowInvoice(true);

      setTimeout(async () => {
        const input = invoiceRef.current;
        const footer = document.getElementById("footer-to-capture");

        if (!input || !footer) {
          setLoading(false);
          return;
        }

        // Hide footer temporarily
        footer.style.display = "none";

        try {
          const scale = 2;
          const canvas = await html2canvas(input, {
            scale,
            useCORS: true,
            allowTaint: true,
            scrollY: -window.scrollY,
          });

          // Show footer back
          footer.style.display = "";

          // Capture footer separately
          const footerCanvas = await html2canvas(footer, {
            scale,
            useCORS: true,
            allowTaint: true,
          });

          const imgWidth = 595.28;
          const pageHeight = 841.89;
          const imgHeight = (imgWidth * canvas.height) / canvas.width;

          const pdf = new jsPDF("p", "pt", "a4");

          let heightLeft = imgHeight;
          let position = 0;
          let pageCount = 0;
          const paddingTop = 40;

          while (heightLeft > 0) {
            const pageCanvas = document.createElement("canvas");
            pageCanvas.width = canvas.width;

            const sliceHeightPx = (pageHeight * canvas.width) / imgWidth;
            const remainingHeight = canvas.height - (sliceHeightPx * pageCount);
            pageCanvas.height = Math.min(sliceHeightPx, remainingHeight);

            const pageCtx = pageCanvas.getContext("2d");
            pageCtx.drawImage(
              canvas,
              0,
              sliceHeightPx * pageCount,
              canvas.width,
              pageCanvas.height,
              0,
              0,
              canvas.width,
              pageCanvas.height
            );

            const imgData = pageCanvas.toDataURL("image/jpeg", 0.95);
            const pageImgHeight = (imgWidth * pageCanvas.height) / canvas.width;
            const yPosition = pageCount === 0 ? 0 : paddingTop;

            pdf.addImage(imgData, "JPEG", 0, yPosition, imgWidth, pageImgHeight);

            heightLeft -= pageHeight;
            pageCount++;

            if (heightLeft > 0) {
              pdf.addPage();
            }
          }

          // Add footer on last page
          const footerImg = footerCanvas.toDataURL("image/png", 0.95);
          const footerHeight = (imgWidth * footerCanvas.height) / footerCanvas.width;
          const pageCountTotal = pdf.internal.getNumberOfPages();
          pdf.setPage(pageCountTotal);

          const footerYPosition = pageHeight - footerHeight - 20;
          pdf.addImage(footerImg, "PNG", 0, footerYPosition, imgWidth, footerHeight);

          // Convert PDF to blob
          const pdfBlob = pdf.output("blob");
          const pdfSizeMB = pdfBlob.size / 1024 / 1024;

          if (pdfSizeMB > MAX_PDF_SIZE_MB) {
            alert(`Generated PDF is too large (${pdfSizeMB.toFixed(2)} MB). Please reduce content.`);
            setShowInvoice(false);
            setLoading(false);
            return;
          }

          const formDataToUpload = new FormData();
          for (const key in formData) {
            if (formData[key] !== undefined && formData[key] !== null) {
              formDataToUpload.append(key, formData[key]);
            }
          }

          formDataToUpload.set("age", parseInt(formData.age || 0));
          formDataToUpload.set("height_cm", parseFloat(formData.height_cm || 0));
          formDataToUpload.set("weight_kg", parseFloat(formData.weight_kg || 0));
          formDataToUpload.set("bmi", parseFloat(formData.bmi || 0));
          formDataToUpload.set("body_fat_percent", parseFloat(formData.body_fat_percent || 0));
          formDataToUpload.set("visceral_fat_level", parseFloat(formData.visceral_fat_level || 0));
          formDataToUpload.set("body_age", parseInt(formData.body_age || 0));
          formDataToUpload.set("resting_metabolism_kcal", parseInt(formData.resting_metabolism_kcal || 0));
          formDataToUpload.append("created_at", new Date().toISOString().split("T")[0]);
          formDataToUpload.append("pdf_file", pdfBlob, "BMI_Report.pdf");

          const response = await fetch("https://feedback.pranaamhospitals.com/index.php/BMI/bmi_assessment", {
            method: "POST",
            body: formDataToUpload,
          });

          const result = await response.json();

          if (result.status === "Success") {
            setShowInvoice(false);
            resetForm();
            setShowSuccessPopup(true);
          } else {
            console.error("Server error:", result.message || result);
          }

          setLoading(false);
        } catch (error) {
          console.error("Error during PDF generation or submission:", error);
          setLoading(false);
          setShowInvoice(false);
        }
      }, 200);
    } else {
      const firstError = document.querySelector(".text-red-500");
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };







  const resetForm = () => {
    setFormData({
      full_name: "",
      gender: "",
      age: "",
      // date_of_birth: "",
      contact_number: "",
      height_cm: "",
      weight_kg: "",
      bmi: "",
      body_fat_percent: "",
      visceral_fat_level: "",
      body_age: "",
      resting_metabolism_kcal: "",
      concern: "",
      observation: "",
      suggestion: "",
      doctor_name: "",
    })
    setErrors({})
    setCalculatedBMI("")
  }

  // Print form
  const handlePrint = () => {
    window.print()
  }

  // BMI Category function
  const getBMICategory = (bmi) => {
    const numericBMI = typeof bmi === "string" ? Number.parseFloat(bmi) : bmi

    if (isNaN(numericBMI)) {
      return { category: "", color: "" }
    }

    let category = ""
    let color = ""

    if (numericBMI < 18.5) {
      category = "Underweight"
      color = "text-blue-600"
    } else if (numericBMI >= 18.5 && numericBMI < 25) {
      category = "Normal weight"
      color = "text-green-600"
    } else if (numericBMI >= 25 && numericBMI < 30) {
      category = "Overweight"
      color = "text-yellow-600"
    } else if (numericBMI >= 30 && numericBMI < 35) {
      category = "Obesity Class I"
      color = "text-orange-600"
    } else if (numericBMI >= 35 && numericBMI < 40) {
      category = "Obesity Class II"
      color = "text-red-500"
    } else {
      category = "Obesity Class III"
      color = "text-red-700"
    }

    return { category, color }
  }

  const handleReturnToForm = () => {
    setShowSuccessPage(false)
    resetForm()
  }

  // This is just for testing - remove in production
  const testShowSuccessPage = () => {
    setShowSuccessPage(true)
  }

  const bmiCategory = getBMICategory(calculatedBMI)



  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <div style={{ textAlign: 'center' }}>
            <div className="loader"></div>
            <h1>Loading, please wait.....</h1>
          </div>
        </div>
      )}
      <div className="min-h-screen bg-gray-50 w-fit p-[10px] lg:w-full lg:p-0 main-container">
        <div className="max-w-4xl mx-auto p-4 inner-container">
          <div className="flex items-center justify-between py-4 border-b border-gray-200 mb-8">
            <div className="flex items-center">
              <div className="mr-3 w-20 h-12 relative mb-2">
                <img
                  src={image || "/placeholder.svg"}
                  alt="Pranaam Hospitals Logo"
                  width="auto"
                  height={45}
                  className="object-contain"
                  marginbottom="10px"
                />
              </div>
            </div>
            <div>
              <a href="tel:8106766066" ><button className="text-[#8B1D1D] font-medium">Call : 8106766066</button></a>
            </div>
          </div>

          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-800">BMI & Body Composition Assessment Form</h1>
            <div className="mt-2 text-gray-600">
              <p className="font-medium">Dr. Aarti</p>
              <p>Physiotherapist, Clinical Nutritionist, Natural Birthing Expert & Yoga Therapist</p>
              <p>Phone: 8106766066</p>
            </div>
          </div>

          {submitStatus.show && (
            <div
              className={`${submitStatus.success ? "bg-green-100 border-green-400 text-green-700" : "bg-red-100 border-red-400 text-red-700"} px-4 py-3 rounded relative mb-6 border`}
            >
              <strong className="font-bold">{submitStatus.success ? "Success!" : "Error!"}</strong>
              <span className="block sm:inline"> {submitStatus.message}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Patient Information */}
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
              <div className="bg-gray-50 p-6 rounded-t-lg border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800">Patient Information</h3>
                <p className="text-sm text-gray-600">Enter the patient's personal details</p>
              </div>
              <div className="p-6 space-y-6">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Full Name</label>
                  <input
                    name="full_name"
                    type="text"
                    placeholder="Enter full name"
                    className={`w-full px-3 py-2 border ${errors.full_name ? "border-red-500" : "border-gray-300"
                      } rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]`}
                    value={formData.full_name}
                    onChange={handleInputChange}
                  />
                  {errors.full_name && <p className="text-sm font-medium text-red-500">{errors.full_name}</p>}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Gender</label>
                    <select
                      name="gender"
                      className={`w-full px-3 py-2 border ${errors.gender ? "border-red-500" : "border-gray-300"
                        } rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]`}
                      value={formData.gender}
                      onChange={handleInputChange}
                    >
                      <option value="">Select gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                    {errors.gender && <p className="text-sm font-medium text-red-500">{errors.gender}</p>}
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Age</label>
                    <input
                      name="age"
                      type="number"
                      placeholder="Enter age"
                      className={`w-full px-3 py-2 border ${errors.age ? "border-red-500" : "border-gray-300"
                        } rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]`}
                      value={formData.age}
                      onChange={handleInputChange}
                    />
                    {errors.age && <p className="text-sm font-medium text-red-500">{errors.age}</p>}
                  </div>

                  {/* <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Date of Birth</label>
                  <input
                    name="date_of_birth"
                    type="date"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                    value={formData.date_of_birth}
                    onChange={handleInputChange}
                  />
                </div> */}
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Contact Number</label>
                  <input
                    name="contact_number"
                    type="text"
                    placeholder="Enter contact number"
                    className={`w-full px-3 py-2 border ${errors.contact_number ? "border-red-500" : "border-gray-300"
                      } rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]`}
                    value={formData.contact_number}
                    onChange={handleInputChange}
                  />
                  {errors.contact_number && <p className="text-sm font-medium text-red-500">{errors.contact_number}</p>}
                </div>
              </div>
            </div>

            {/* Anthropometric & Body Composition Data */}
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
              <div className="bg-gray-50 p-6 rounded-t-lg border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800">Anthropometric & Body Composition Data</h3>
                <p className="text-sm text-gray-600">Enter the patient's body measurements</p>
              </div>
              <div className="p-6">
                <div className="overflow-x-auto max-w-screen-sm m-auto">
                  <table className="w-full border-collapse min-w-[500px]">
                    <thead>
                      <tr className="bg-gray-50 tr">
                        <th className="text-left py-2 px-4 border-b border-gray-200 text-gray-700">Metric</th>
                        <th className="text-left py-2 px-4 border-b border-gray-200 text-gray-700">Value</th>
                        <th className="text-left py-2 px-4 border-b border-gray-200 text-gray-700">Reference Range</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="tr">
                        <td className="py-2 px-4 border-b border-gray-100">Height (cm)</td>
                        <td className="py-2 px-4 border-b border-gray-100">
                          <div className="space-y-2">
                            <input
                              name="height_cm"
                              type="number"
                              placeholder="Enter height"
                              className={`w-full max-w-md px-3 py-2 border ${errors.height_cm ? "border-red-500" : "border-gray-300"
                                } rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]`}
                              value={formData.height_cm}
                              onChange={handleInputChange}
                            />
                            {errors.height_cm && <p className="text-sm font-medium text-red-500">{errors.height_cm}</p>}
                          </div>
                        </td>
                        <td className="py-2 px-4 border-b border-gray-100"></td>
                      </tr>
                      <tr className="tr">
                        <td className="py-2 px-4 border-b border-gray-100">Weight (kg)</td>
                        <td className="py-2 px-4 border-b border-gray-100">
                          <div className="space-y-2">
                            <input
                              name="weight_kg"
                              type="number"
                              placeholder="Enter weight"
                              className={`w-full px-3 py-2 border ${errors.weight_kg ? "border-red-500" : "border-gray-300"
                                } rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]`}
                              value={formData.weight_kg}
                              onChange={handleInputChange}
                            />
                            {errors.weight_kg && <p className="text-sm font-medium text-red-500">{errors.weight_kg}</p>}
                          </div>
                        </td>
                        <td className="py-2 px-4 border-b border-gray-100"></td>
                      </tr>
                      <tr className="tr">
                        <td className="py-2 px-4 border-b border-gray-100">BMI</td>
                        <td className="py-2 px-4 border-b border-gray-100">
                          <div className="flex items-center space-x-2">
                            <input
                              name="bmi"
                              type="text"
                              placeholder="Calculated BMI"
                              value={calculatedBMI}
                              readOnly
                              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                            />

                          </div>
                          {calculatedBMI && <span className={bmiCategory.color}>{bmiCategory.category}</span>}
                        </td>
                        <td className="py-2 px-4 border-b border-gray-100">18.5 – 24.9</td>
                      </tr>
                      <tr>
                        <td className="py-2 px-4 border-b border-gray-100">Body Fat %</td>
                        <td className="py-2 px-4 border-b border-gray-100">
                          <input
                            name="body_fat_percent"
                            type="number"
                            placeholder="Enter body fat %"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                            value={formData.body_fat_percent}
                            onChange={handleInputChange}
                          />
                        </td>
                        <td className="py-2 px-4 border-b border-gray-100">10% – 25%</td>
                      </tr>
                      <tr>
                        <td className="py-2 px-4 border-b border-gray-100">Visceral Fat Level</td>
                        <td className="py-2 px-4 border-b border-gray-100">
                          <input
                            name="visceral_fat_level"
                            type="number"
                            placeholder="Enter visceral fat level"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                            value={formData.visceral_fat_level}
                            onChange={handleInputChange}
                          />
                        </td>
                        <td className="py-2 px-4 border-b border-gray-100">1 – 10</td>
                      </tr>
                      <tr>
                        <td className="py-2 px-4 border-b border-gray-100">Body Age</td>
                        <td className="py-2 px-4 border-b border-gray-100">
                          <input
                            name="body_age"
                            type="number"
                            placeholder="Enter body age"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                            value={formData.body_age}
                            onChange={handleInputChange}
                          />
                        </td>
                        <td className="py-2 px-4 border-b border-gray-100">(Should not exceed real age)</td>
                      </tr>
                      <tr>
                        <td className="py-2 px-4 border-b border-gray-100">Resting Metabolism (Kcal/day)</td>
                        <td className="py-2 px-4 border-b border-gray-100">
                          <input
                            name="resting_metabolism_kcal"
                            type="number"
                            placeholder="Enter resting metabolism"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                            value={formData.resting_metabolism_kcal}
                            onChange={handleInputChange}
                          />
                        </td>
                        <td className="py-2 px-4 border-b border-gray-100">1200 – 2200</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Clinical Notes */}
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
              <div className="bg-gray-50 p-6 rounded-t-lg border-b border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800">Clinical Notes</h3>
                <p className="text-sm text-gray-600">To be filled by Staff</p>
              </div>
              <div className="p-6 space-y-6">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Primary Concern</label>
                  <textarea
                    name="concern"
                    placeholder="Enter primary concern"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D] min-h-[80px]"
                    value={formData.concern}
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Observations</label>
                  <textarea
                    name="observation"
                    placeholder="Enter observations"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D] min-h-[80px]"
                    value={formData.observation}
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Suggested Action</label>
                  <textarea
                    name="suggestion"
                    placeholder="Enter suggested action"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D] min-h-[80px]"
                    value={formData.suggestion}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                <div className="space-y-2">
                  <p className="text-sm font-medium text-gray-700">Doctor Name</p>
                  <input
                    name="doctor_name" // match this to your formData key
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                    value={formData.doctor_name}
                    onChange={handleInputChange}
                  />

                </div>
              </div>
            </div>
            <div className="border-gray-200 shadow-sm">
              <div className="p-6 pt-0 flex justify-end space-x-4">
                <button
                  type="button"
                  onClick={resetForm}
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#8B1D1D]"
                >
                  Reset
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`px-4 py-2 border border-transparent rounded-md text-white bg-[#8B1D1D] hover:bg-[#7A1919] focus:outline-none focus:ring-2 focus:ring-[#8B1D1D] ${isSubmitting ? "opacity-75 cursor-not-allowed" : ""}`}
                >
                  {isSubmitting ? "Submitting..." : "Submit Form"}
                </button>
              </div>
            </div>
          </form>

          <footer className="mt-8 text-center text-sm text-gray-600 mt-25">
            <p>© {new Date().getFullYear()} Pranaam Hospitals. All rights reserved.</p>
          </footer>
        </div>
        {showInvoice && (
          <div
            className="invoice-preview"
            ref={invoiceRef}
            style={{
              ...styles.invoiceBox,
              position: 'absolute',
              top: '-9999px', // hide off-screen
              left: '-9999px',
              display: showInvoice ? 'block' : 'none',
              paddingBottom: '120px'

            }}
          >
            <div
              style={{
                backgroundColor: materialColors.background,
                // padding: "40px",
                margin: '0',
                paddingTop: '0',
                minHeight: "100vh",
                color: materialColors.textPrimary,
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              }}
            >
              <div
                // ref={formRef}
                style={{
                  maxWidth: "800px",
                  margin: "auto",
                  backgroundColor: materialColors.cardBackground,
                  // padding: "40px",
                  // borderRadius: "12px",
                  // border: `1px solid ${materialColors.border}`,
                  color: materialColors.textPrimary,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                <div className="flex items-center justify-center w-full gap-4" >
                  <img src={pranaamlogo} alt="pranam-logo" style={{ width: "auto", height: "50px", objectFit: "contain", marginTop: '0' }} />
                </div>
                <h1
                  style={{
                    textAlign: "center",
                    fontSize: "20px",
                    color: "rgb(139, 29, 29)",
                    fontWeight: "600",
                    // marginTop: "20px",
                    letterSpacing: "1px",
                    marginBottom: '10px',
                    borderBottom: `2px solid ${materialColors.border}`,
                    paddingBottom: '20px'
                  }}
                >
                  BMI Report
                </h1>

                {/* Patient Info */}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto 10px auto auto 10px auto",
                    rowGap: "8px",
                    columnGap: "10px",
                    fontSize: "12px",
                    color: "black",
                  }}
                >
                  {/* Row 1 */}
                  <span style={labelStyle}>Patient Name</span>
                  <span style={colonStyle}>:</span>
                  <span style={valueStyle}>{formData.full_name || "N/A"}</span>

                  <span style={labelStyle}>Gender</span>
                  <span style={colonStyle}>:</span>
                  <span style={valueStyle}>{formData.gender || "N/A"}</span>

                  {/* Row 2 */}
                  <span style={labelStyle}>Age</span>
                  <span style={colonStyle}>:</span>
                  <span style={valueStyle}>{formData.age || "N/A"}</span>

                  <span style={labelStyle}>Contact Number</span>
                  <span style={colonStyle}>:</span>
                  <span style={valueStyle}>{formData.contact_number || "N/A"}</span>
                </div>







                {/* Measurements Table */}
                <div style={{ marginBottom: "10px" }}>
                  <h2
                    style={{
                      // marginLeft: '15px',
                      fontSize: "12px",
                      color: "rgb(139, 29, 29)",
                      marginTop: "5px",
                      // marginBottom: "16px",
                    }}
                  >
                    Body Composition
                  </h2>
                  {/* <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 'bold', fontSize: '12px' }}>
                    <tbody>
                      {[
                        ["Height (cm)", formData.height_cm],
                        ["Weight (kg)", formData.weight_kg],
                        ["BMI", formData.bmi],
                        ["Body Fat Percent", formData.body_fat_percent],
                        ["Visceral Fat Level", formData.visceral_fat_level],
                        ["Body Age", formData.body_age],
                        ["Resting Metabolism (kcal)", formData.resting_metabolism_kcal],
                      ].map(([label, value]) => (
                        <tr
                          key={label}
                          style={{ borderBottom: `1px solid ${materialColors.border}`, fontSize: '12px' }}
                        >
                          <td style={{ padding: "10px 0", color: materialColors.textSecondary }}>
                            {label}
                          </td>
                          <td
                            style={{
                              // padding: "10px 0",
                              color: materialColors.textPrimary,
                              textAlign: "right",
                            }}
                          >
                            {value || "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table> */}
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", marginTop: "8px" }}>
                    <thead>
                      <tr style={{ borderBottom: `1px solid ${materialColors.border}` }}>
                        <th style={{ textAlign: "left", color: "rgb(139, 29, 29)", padding: "8px", color: materialColors.textSecondary }}>Parameter</th>
                        <th style={{ textAlign: "left", color: "rgb(139, 29, 29)", padding: "8px", color: materialColors.textSecondary }}>Value</th>
                        <th style={{ textAlign: "right", color: "rgb(139, 29, 29)", padding: "8px", color: materialColors.textSecondary }}>Reference</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Height (cm)", formData.height_cm, "-"],
                        ["Weight (kg)", formData.weight_kg, "-"],
                        ["BMI", formData.bmi, "18.5 – 24.9"],
                        ["Body Fat Percent", formData.body_fat_percent, "10% – 25%"],
                        ["Visceral Fat Level", formData.visceral_fat_level, "1 – 10"],
                        ["Body Age", formData.body_age, "Should not exceed real age"],
                        ["Resting Metabolism (kcal)", formData.resting_metabolism_kcal, "1200 – 2200"],
                      ].map(([label, value, reference]) => (
                        <tr
                          key={label}
                          style={{
                            borderBottom: `1px solid ${materialColors.border}`,
                            verticalAlign: "middle",
                          }}
                        >
                          <td style={{ padding: "10px", color: materialColors.textSecondary, textAlign: "left" }}>
                            {label}
                          </td>

                          <td style={{ padding: "10px", color: materialColors.textPrimary, textAlign: "left" }}>
                            {value || "N/A"}
                          </td>
                          <td style={{ padding: "10px", color: materialColors.textSecondary, textAlign: "right" }}>
                            {reference}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>


                </div>

                {/* Observations */}
                <div style={{ display: 'grid', flexDirection: 'column', gap: '10px', fontSize: '12px' }}>
                  {[
                    ["Concern", formData.concern],
                    ["Observation", formData.observation],
                    ["Suggestion", formData.suggestion],
                    ["Doctor Name", formData.doctor_name],
                  ].map(([label, value]) => (
                    <div key={label}>
                      <p style={{ fontSize: "12px", lineHeight: 1.6 }}>
                        <strong style={{ color: "rgb(139, 29, 29)" }}>{label}:</strong>{" "}
                        {value || "N/A"}
                      </p>
                    </div>
                  ))}
                </div>


                {/* <footer className="text-sm w-full"> */}
                <footer id="footer-to-capture" className="text-sm w-full" style={{
                  maxHeight: "120px",
                  padding: "8px 0",
                  fontSize: "12px",
                  lineHeight: "1.4",
                }}>
                  <div className="text-center mb-4">
                    <div className="mt-2 text-gray-600">
                      <p className="font-medium text-black" style={{ fontSize: '12px' }}>Dr. Aarti</p>
                      <p className="text-black" style={{ fontSize: '12px' }}>Physiotherapist, Clinical Nutritionist, Natural Birthing Expert & Yoga Therapist</p>
                      <p className="text-black" style={{ fontSize: '12px' }}>Phone: 8106766066</p>
                    </div>
                  </div>
                  <div className="text-center text-sm text-black shadow-sm mt-0 mb-0" style={{ borderTop: '1px solid black' }}>
                    <p style={{ fontSize: '12px' }}>© {new Date().getFullYear()} Pranaam Hospitals. All rights reserved.</p>
                  </div>
                </footer>

              </div>
            </div>
          </div>

        )}
      </div>
      {showSuccessPopup && <SuccessModal onClose={() => setShowSuccessPopup(false)} />}
    </>
  )
}

const styles = {
  invoiceBox: {
    width: '600px',
    margin: '40px auto',
    padding: '30px',
    fontFamily: 'Arial, sans-serif',
    fontSize: '16px',
    backgroundColor: '#fff',
    color: '#333',
  },
  center: {
    textAlign: 'center',
  },
};

export default BMIForm

